import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { DocumentoPreEditado } from '../_models/DocumentoPreEditado';

@Injectable({
    providedIn: 'root'
})

export class NaoFiscalService {

    constructor(private http: HttpClient, private datePipe: DatePipe,) { }

        CriarProtocoloNaoFiscal(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/naofiscal`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

         return this.http.post<any>(apiURL, formDataUpload, options);
    }

    AtualizarProtocoloNaoFiscal(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/naofiscal`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
            headers: headers
        };

        return this.http.put<any>(apiURL, formDataUpload, options);
    }

    CancelarProtocoloNaoFiscal(protocolo: DocumentoPreEditado): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/naofiscal/cancelar`;
        return this.http.post<any>(apiURL, protocolo);
    }

    VerificaDuplicidadeNaoFiscal(protocolo: DocumentoPreEditado): Observable<any> {
        //Mt 8.5-13
        const dataEmissaoNfe = this.datePipe.transform(protocolo.dataEmissaoNf, 'yyyy-MM-dd');
        const dataVencimentoNfe = this.datePipe.transform(protocolo.dataVencimentoNf, 'yyyy-MM-dd');

        const apiURL = `${environment.apiUrl}/api/naofiscal/duplicidade`;

        const body = {
            valor : protocolo.valor,
            idProtocolo : protocolo.idProtocolo,
            fornecedor : protocolo.cnpjfornecedor,
            divisao : protocolo.divisao,
            tipoDocumento : protocolo.idTipoDocumento,
            dtEmissao : dataEmissaoNfe,
            dtVencimento : dataVencimentoNfe
        }

        return this.http.post<any>(apiURL, body);
    }


}
